import { useIsV2Supported } from "./useIsV2Supported";
import * as V1 from "./V1";
import * as V2 from "./V2";

export const DocumentViewer = {
  V1: V1.DocViewer,
  V2: V2.DocumentViewer,
  useIsV2Supported,
};
